import React, {Component} from 'react';
import axios from 'axios';
import {FaBell} from "react-icons/fa";
import { BsClock } from "react-icons/bs";
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import {Spinner} from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";
import {Link} from "react-router-dom";

class DetailNotificationComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            notification: {},
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getDetailNotification(this.props.notificationId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.notificationId !== prevProps.notificationId) {
            this.getDetailNotification( this.props.notificationId );
        }
    }

    getDetailNotification = (notificationId) => {
        this.setState({
            loadPage: true,
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get(process.env.REACT_APP_API_URL + '/api/notification/getDetailNotification/' + notificationId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        notification: ref.data.notification,
                        loadPage: false,
                        isLoading: false,
                    },
                    () => this.loadUnreadNotification()
                    )
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    } else if (ref.data.error > 7999) {
                        this.redirect();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu thông báo thất bại',
                })
            })
    }

    loadUnreadNotification = () => {
        if(this.props.notifications.length > 0) {
            this.props.notifications.forEach( (notification) => {
                if (notification.id === this.state.notification.id) {
                    this.getUnReadNotifications();
                }
            });
        }
    }

    getUnReadNotifications = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let config = {
              headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            } 
        }

        axios.get(process.env.REACT_APP_API_URL + '/api/notification/get-unread-notifications', config )
        .then((ref) => {
            // console.log(ref.data);
            if (ref.data.error === 0) {
                this.updateNotification(ref.data)
            } else {
                if (ref.data.error > 9000) {
                    this.props.logOut();
                } else {
                    this.setState({
                        error: true,
                        messageError: ref.data.message
                    })
                }
            }
        })
        .catch((error) => {
            console.log(error);
            this.setState({
                error: true,
                messageError: 'Lấy dữ liệu thông báo thất bại',
            })
        })
      }

    updateNotification = (data) => {
        // console.log(data);
        let itemNotification = {
          notifications: data.notifications,
          unread_notification: data.unread_notification
        }
        this.props.updateNotification(itemNotification);
    }

    loadDetailNotification = () => {
        if (this.state.error) {
            return (
                <Alert color="danger">
                    {this.state.messageError}
                </Alert>
            )
        } else {
            if (Object.keys(this.state.notification).length) {
                return (
                    <div className="card border-bottom-info border-header-info shadow" style={{marginTop: 20,}}>
                        <div className="card-header">
                            <h3 className="card-title" style={{margin: 0}}>
                                { this.state.notification.title }
                            </h3>
                            <div style={{color: '#999', fontSize: 13}}>
                                <BsClock /> {this.state.notification.text_created_at}
                            </div>
                        </div>
                        <div className="card-body table-responsive">
                            <div className="content-noti" dangerouslySetInnerHTML={{ __html: this.state.notification.content }}>
                            </div>
                        </div>
                        <div className="card-footer clearfix">
                            <div>
                                <Link to="/thong-bao/danh-sach-thong-bao.html" className="btn btn-default">Tất cả thông báo</Link>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    redirect = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Thông báo không tồn tại hoặc không thuộc quyền quản lý của quý khách. Quý khách vui lòng kiểm tra lại'
        });
        this.props.shouldRedirect();
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chi tiết thông báo"} page={"Thông báo"}
                                                icon={<FaBell className="breadcrumb-icon"/>}/>
                            {
                                this.loadDetailNotification()
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
        notifications: state.user.notifications,
        unread_notification: state.user.unread_notification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type: 'logOut'}))
        },
        notification: (item) => {
            dispatch(({type: 'notification', item}))
        },
        updateCredit: (item) => {
            dispatch(({type: 'updateCredit', item}))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({type: 'updateSuccessNotiUser', item}))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({type: 'updateErrorNotiUser', item}))
        },
        updateNotification: (item) => {
            dispatch(({type: 'updateNotification', item}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailNotificationComponent);